import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';


const tagName = 'div';

register('wm-video', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {

          return `<${tagName} wmVideo  ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
